export default __webpack_public_path__ + "static/no_image-e1ce751ef1b590f719f9ce23787a7ac6.jpg";